import { QBankStructureType } from '@exam-management/graphql';
import { Label, type LabelProps, StarRoundedIcon } from '@shared/components';
import { capitalize } from '@shared/utils';

export interface QBankStructureTypeTagProps extends LabelProps {
  type: QBankStructureType;
}

export default function QBankStructureTypeTag(props: Readonly<QBankStructureTypeTagProps>) {
  const { type, sx, ...restProps } = props;

  return (
    <Label
      size='large'
      borderType='round'
      startIcon={
        type === QBankStructureType.Main ? (
          <StarRoundedIcon
            sx={{
              color: (theme) => theme.palette.primary.main,
              fontSize: 16,
            }}
          />
        ) : undefined
      }
      sx={{
        color: (theme) => theme.palette.grey[700],
        borderColor: (theme) => theme.palette.primary.light,
        backgroundColor: (theme) => theme.palette.primary.lighter,
        ...sx,
      }}
      {...restProps}
    >
      {capitalize(type)}
    </Label>
  );
}
